// @flow

import React from 'react';
import ReactAI from 'react-appinsights';

type Props = {
    colorString: string
}

let ColorBadge = (props: Props) => {
    return (
        <span style={{color: props.colorString}} className="fas fa-stop"></span>
    );
};

export default ReactAI.withTracking(ColorBadge);




// WEBPACK FOOTER //
// ./src/components/ColorBadge.js